import * as React from 'react';
import { observer } from 'mobx-react';

import CodeCell from './components/code-cell/CodeCell';
import PlaygroundStore from './stores/PlaygroundStore';

export interface PlaygroundProps {
  store: PlaygroundStore;
}

@observer
export default class Playground extends React.Component<PlaygroundProps> {

  private _keyUpHandler = (e: KeyboardEvent) => {
    if (e.shiftKey && e.keyCode === 13) { // shift + enter
      this.props.store.executeSelectedScript();
      e.stopPropagation();
      e.preventDefault();
    }
  }

  componentDidMount() {
    document.addEventListener('keyup', this._keyUpHandler);
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this._keyUpHandler);
  }

  render() {
    const { cells } = this.props.store;

    return (
      <div className="root">
        <div className="navbar navbar-shadow">
          <div className="container">
            <h1 className="navbar-brand">GreyCat PlayGround</h1>
          </div>
        </div>
        <div className="site">
          <div className="site-content container p-5">
            <h3>Usage:</h3>
            <div className="help text-center">
              <i className="float-left oi oi-info" />
              <p>To run the selected code cell, hit:</p>
              <span style={{ fontSize: 28 }}>Shift + Enter</span>
            </div>

            <h3>Variable declaration:</h3>
            <p className="text-justify">
              You can declare variables using the keyword <code>var</code> and a JavaScript-like syntax.
            </p>
            <div className="scripts">
              {cells.filter((c) => c.category === 'varDecl').map((c, i) => (
                <CodeCell
                  key={i}
                  className="cell"
                  pgStore={this.props.store}
                  store={c}
                />
              ))}
            </div>
            <h3>Standard output:</h3>
            <p className="text-justify">
              Calling <code>print(...)</code> will output content into your browser's console.
            </p>
            <div className="scripts">
              {cells.filter((c) => c.category === 'stdout').map((c, i) => (
                <CodeCell
                  key={i}
                  className="cell"
                  pgStore={this.props.store}
                  store={c}
                />
              ))}
            </div>
            <h3>Custom types:</h3>
            <p className="text-justify">
              You can create your own types using the keyword <code>type</code>.
            </p>
            <div className="scripts">
              {cells.filter((c) => c.category === 'typing').map((c, i) => (
                <CodeCell
                  key={i}
                  className="cell"
                  pgStore={this.props.store}
                  store={c}
                />
              ))}
            </div>
            <h3>Take control:</h3>
            <div className="scripts">
              {cells.filter((c) => c.category === 'user').map((c, i) => (
                <CodeCell
                  key={i}
                  className="cell"
                  pgStore={this.props.store}
                  store={c}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
